import { useEffect, useState } from "react";
import { get_categories, get_channels } from "../../../server/requests";
import RowList from "../../Row_List/RowList";
import Loading from "../../Loading/Loading";

export default function Channels({ isGuest }) {

    const [allChannels, setAllChannels] = useState([])
    const [categories, setCategories] = useState([])
    const [channels, setChannels] = useState({})
    const [showLoading, setShowLoading] = useState(false)

    useEffect(() => {
        setShowLoading(true)
        get_channels({}, data => {
            setAllChannels([...data])
        }, err => console.log(err, 'error'))
        get_categories({}, data => {
            setCategories([...data])

        }, err => console.log(err, 'error'))
    }, [])

    useEffect(() => {
        if (categories.length && allChannels.length) {
            sort_channels()
        }
    }, [allChannels, categories])

    const sort_channels = () => {

        let _categories = {};

        for (let i = 0; i < categories.length; i++) {

            categories[i].content = [];

            let id = categories[i].id;

            _categories[id] = categories[i];

        }


        for (let j = 0; j < allChannels.length; j++) {

            for (let k = 0; k < allChannels[j].categories.length; k++) {

                let c_id = allChannels[j].categories[k];

                if (_categories[c_id]) _categories[c_id].content.push(allChannels[j])

            }

        }

        setChannels({ ..._categories })
        setShowLoading(false)

    }

    return (
        <div className="container">
            <div className="channels_list">

                {showLoading ?
                    <Loading />
                    : Object.values(channels).map((elem, index) => {
                        return (
                            elem.content.length ? <RowList
                                key={elem.id}
                                title={elem.name}
                                type={'live_tv'}
                                row={elem}
                                array={elem.content}
                                rowIndex={index}
                                isGuest={isGuest}
                            /> : null
                        )
                    })}
            </div>
        </div>
    )
}